import { useState, useEffect } from 'react';

export const usePartyMode = () => {
  const [isActive, setIsActive] = useState(false);
  const [showGifs, setShowGifs] = useState(false);

  // Check for party query parameter on mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('party') !== null) {
      activatePartyMode();
    }
  }, []);

  const activatePartyMode = () => {
    setIsActive(true);
    // Add party mode class to body for global effects
    document.body.classList.add('party-mode');
  };

  const deactivatePartyMode = () => {
    setIsActive(false);
    setShowGifs(false);
    document.body.classList.remove('party-mode');
  };

  const toggleGifs = () => {
    if (isActive) {
      setShowGifs(!showGifs);
    }
  };


  // Handle escape key to deactivate party mode and 'd' key to show GIFs
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isActive) {
        deactivatePartyMode();
      } else if (event.key === 'd' && isActive) {
        setShowGifs(!showGifs);
      }
    };

    if (isActive) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [isActive, showGifs]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      document.body.classList.remove('party-mode');
    };
  }, []);

  return {
    isActive,
    showGifs,
    activatePartyMode,
    deactivatePartyMode,
    toggleGifs
  };
};
